module.exports = __webpack_public_path__ + "img/start_hw.f9ec6d3e.png";